import { AnimatePresence, motion } from "motion/react";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui";
import { spring } from "@/lib/motion";
import { applyUpdate, useUpdateAvailable } from "./register";

/** "Nueva versión disponible · Actualizar", above the tab bar once a new deploy is waiting. */
export function UpdatePrompt() {
  const available = useUpdateAvailable();
  return (
    <AnimatePresence>
      {available && (
        <motion.div
          role="status"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 12 }}
          transition={spring.gentle}
          className="fixed inset-x-0 bottom-[calc(env(safe-area-inset-bottom)+92px)] z-40 flex justify-center px-4 lg:bottom-6 lg:pl-[248px]"
        >
          <div className="flex items-center gap-2 rounded-full py-1.5 pr-1.5 pl-4 text-subhead font-medium whitespace-nowrap glass">
            <RefreshCw className="size-4 shrink-0 text-accent" aria-hidden />
            Nueva versión disponible
            <Button variant="secondary" className="min-h-9 rounded-full px-4" onClick={applyUpdate}>
              Actualizar
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
